import { requestEditorToken } from "./editorAuth";

export const urlApi =
  import.meta.env.VITE_LC_API_URL ?? "https://api.leadcars.es";

/**
 * Cabeceras con el token de sesión del editor (ver editorAuth.js).
 *
 * Si no se consigue el token se llama sin él, como antes: quien exige la autenticación es el
 * API. Así el editor sigue funcionando con un API anterior al token mientras se despliega, y con
 * el API nuevo la llamada acaba en 401, que el editor muestra como error.
 *
 * @param {Record<string, string>} headers
 * @returns {Promise<Record<string, string>>}
 */
async function editorAuthHeaders(headers = {}) {
  try {
    const token = await requestEditorToken();

    return { ...headers, Authorization: `Bearer ${token}` };
  } catch (error) {
    console.warn(error);

    return headers;
  }
}

/**
 *
 * @param id
 * @returns {Promise<boolean|string>}
 * @throws {Error} Si el API responde con error (p. ej. 401 sin token de sesión)
 */
export async function getTemplate(id) {
  console.log("CARGANDO DATOS DEL TEMPLATE");
  const request = await fetch(
    `${urlApi}/api/v2/email/builder/manager/id/${id}`,
    {
      headers: await editorAuthHeaders(),
    }
  );
  if (!request.ok) {
    throw new Error(`HTTP ${request.status}`);
  }
  const response = await request.json();

  if (response && response?.template?.type == "advanced") {
    return response;
  }

  return false;
}

/**
 *
 * @param id
 * @param template
 * @returns {Promise<any>}
 * @throws {Error} Si no se ha guardado, para que el editor no se cierre como si se hubiera guardado
 */
export async function updateTemplate(id, template) {
  const request = await fetch(
    `${urlApi}/api/v2/email/builder/manager/update/${id}`,
    {
      method: "PUT",
      body: JSON.stringify({
        template,
      }),
      headers: await editorAuthHeaders({
        "content-type": "application/json",
      }),
    }
  );

  const response = await request.json().catch(() => null);
  if (!request.ok || !response || response.error) {
    throw new Error(response?.message ?? `HTTP ${request.status}`);
  }

  return response;
}

/**
 *
 * @returns {Promise<any>}
 */
export async function getEmailParamsList(lang) {
  const url = `${urlApi}/api/v2/email/builder/list_parameters?group=emailManager&lang=${lang}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  });
  return await response.json();
}
